<template>
    <div class="home-quote-step passed-insurance">
        <quote-step-header
            :showStep="false"
            :key="currentSubStep"
            :title="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-group">
                <app-label>{{ trans("last_3_years") }}</app-label>
                <app-text-radio-buttons
                    v-model="form[stepName].claims"
                    :message="errors.get('claims')"
                    :items="claimItems"
                    :breakMobile="true"
                >
                </app-text-radio-buttons>
            </div>

            <div class="row-item">
                <template v-if="form[stepName].claims">
                    <template v-for="index in constants.HOME_CLAIMS_MAX_YEARS">
                        <app-label
                            >{{ trans(`claims_${index}_year`) }}
                        </app-label>

                        <div class="form-group">
                            <app-text-radio-buttons
                                v-model="form[stepName][claimsYearKey(index)]"
                                :items="passedInsuranceItems"
                                :message="errors.get('passedInsuranceCount')"
                                rounded-small
                            >
                            </app-text-radio-buttons>
                        </div>
                    </template>
                </template>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "HomeQuotePassedInsurance",

    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },

    methods: {
        claimsYearKey(year) {
            switch (year) {
                case 1:
                    return "oneYear";
                case 2:
                    return "twoYear";
                case 3:
                    return "threeYear";
                default:
                    return "oneYear";
            }
        }
    },
    computed: {
        claimItems() {
            return [
                {
                    label: this.$trans("quote.home.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote.home.no"),
                    value: false
                }
            ];
        },
        passedInsuranceItems() {
            return [
                {
                    label: 0,
                    value: 0
                },
                {
                    label: 1,
                    value: 1
                },
                {
                    label: 2,
                    value: 2
                },
                {
                    label: "3+",
                    value: 3
                }
            ];
        },
        canMoveNext() {
            return this.stepFormFields.claims !== null;
        }
    }
};
</script>

<style lang="scss">
.home-quote-step {
    .quote-form {
        max-width: $mobile;
        height: auto;
        margin: 0 auto;
    }
}

.claims-count-wrap {
    margin: 27px auto 0 auto;
    width: 618px;
    height: 131px;
    background-color: $pale-blue;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
